import React from 'react'

const textToIcon = (field, value, layoutType) => {
  const classes = layoutType == 'table' ? 'w-100 small mb1 tc' : 'mla small mb1 tr'

  let markup
  let prefix = ''

  if(field.prefix !== null && typeof field.prefix !== 'undefined') {
    prefix = field.prefix
  }

  if(field.datatype == 'boolean') {
    if(value == null) {
      return <p className={classes}><span className="red-cross"></span></p>
    }

    const stringValue = value.toString().toLowerCase()
    let icon = stringValue.match(/true|True/gi) !== null ? <span className="grn-tick"></span> : <span className="red-cross"></span>
    return <p className={classes}>{icon}</p>
  }

  if(field.datatype == 'tick') {
    if(value == null) {
      return <p className={classes}></p>
    }

    const keyword = value.toString().slice(0, 7).toString().toLowerCase()
    const text = value.toString()

    const containsBoolean = keyword.match(/yes|no/gi) !== null
    if(containsBoolean) {
      // replace yes/no at start of string with corresponding tick or cross
      // print rest of string afterward
      const stringValue = value.toString()
      let icon = keyword.match(/yes|Yes/gi) !== null ? <span className="grn-tick"></span> : <span className="red-cross"></span>
      markup = <p className={classes}>{icon} {prefix}{text.replace(/yes|Yes|no|No/, '').trim()}</p>
    } else {
      markup = <p className={classes}>{`${prefix}${value.toString()}`}</p>
    }
  } else if(field.datatype == 'kiwi') {
    const kiwiArray = [false, false, false, false, false]
    for(let i = 0; i < parseInt(value); i++) {
      kiwiArray[i] = true
    }
    markup = <p className={classes} >
              {kiwiArray.map((k, i) => k ? <span key={i} className="star-service-green"></span> : <span key={i} className="star-service-grey"></span>)}
            </p>
  } else {
    markup = <p className={classes} dangerouslySetInnerHTML={{__html: `${prefix}${value}`}}></p>
  }

  return markup
}

export default textToIcon
